/* van-badge-configurator.js */
(function () {
  'use strict';

  /* ── state ─────────────────────────────────────────── */
  var state = {
    van:         'VW Crafter 2017+',
    design:      'mountains',
    bgColour:    'Black',
    bgHex:       '#1C1C1C',
    designColour:'White',
    designHex:   '#F5F5F5'
  };

  /* ── element refs ───────────────────────────────────── */
  var bgCircle     = document.getElementById('vbc-bg-circle');
  var designUse    = document.getElementById('vbc-design-use');
  var stealthBar   = document.getElementById('vbc-stealth-bar');
  var vanPreview   = document.getElementById('vbc-van-preview');
  var bgLabel      = document.getElementById('vbc-bg-label');
  var designLabel  = document.getElementById('vbc-design-label');
  var vanSelect    = document.getElementById('vbc-van-model');
  var atcBtn       = document.getElementById('vbc-atc-btn');
  var atcConfirm   = document.getElementById('vbc-atc-confirm');
  var customSubmit = document.getElementById('vbc-custom-submit');
  var stickyFooter = document.getElementById('vbc-sticky-footer');
  var stickyClose  = document.getElementById('vbc-sticky-close');

  /* ── preview update ─────────────────────────────────── */
  function updatePreview() {
    if (bgCircle) bgCircle.setAttribute('fill', state.bgHex);

    if (designUse) {
      designUse.setAttribute('href', '#design-' + state.design);
      designUse.setAttribute('fill', state.designHex);
    }

    var isStealthy = (state.bgColour === state.designColour);
    if (stealthBar) {
      stealthBar.classList.toggle('vbc-stealth-bar--visible', isStealthy);
    }
    if (vanPreview) {
      vanPreview.classList.toggle('vbc-stealth-active', isStealthy);
    }
  }

  /* ── van model select ───────────────────────────────── */
  if (vanSelect) {
    vanSelect.addEventListener('change', function () {
      state.van = this.value;
    });
  }

  /* ── design radios ──────────────────────────────────── */
  document.querySelectorAll('input[name="badge-design"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!this.checked) return;
      state.design = this.value;
      document.querySelectorAll('.vbc-design-btn').forEach(function (btn) {
        btn.classList.remove('vbc-design-btn--active');
      });
      this.closest('.vbc-design-option').querySelector('.vbc-design-btn').classList.add('vbc-design-btn--active');
      updatePreview();
    });
  });
  /* mark initial */
  var checkedDesign = document.querySelector('input[name="badge-design"]:checked');
  if (checkedDesign) {
    checkedDesign.closest('.vbc-design-option').querySelector('.vbc-design-btn').classList.add('vbc-design-btn--active');
  }

  /* ── colour swatches ────────────────────────────────── */
  function initSwatches(groupId, onSelect) {
    var group = document.getElementById(groupId);
    if (!group) return;
    group.querySelectorAll('.vbc-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        group.querySelectorAll('.vbc-swatch').forEach(function (s) {
          s.classList.remove('vbc-swatch--active');
        });
        this.classList.add('vbc-swatch--active');
        onSelect(this.dataset.colour, this.dataset.hex);
        updatePreview();
      });
    });
  }

  initSwatches('vbc-bg-swatches', function (colour, hex) {
    state.bgColour = colour;
    state.bgHex    = hex;
    if (bgLabel) bgLabel.textContent = colour;
  });

  initSwatches('vbc-design-swatches', function (colour, hex) {
    state.designColour = colour;
    state.designHex    = hex;
    if (designLabel) designLabel.textContent = colour;
  });

  /* ── add to cart ────────────────────────────────────── */
  function addToCart(variantId, properties, buttonEl) {
    if (!variantId) return;
    var originalText = buttonEl.textContent;
    buttonEl.disabled    = true;
    buttonEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ quantity: 1, id: variantId, properties: properties }] })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.items) {
        buttonEl.textContent = 'Added ✓';
        if (atcConfirm) atcConfirm.hidden = false;
        setTimeout(function () {
          buttonEl.disabled    = false;
          buttonEl.textContent = originalText;
        }, 3000);
      } else {
        buttonEl.disabled    = false;
        buttonEl.textContent = 'Try again';
        console.warn('Cart error:', data);
      }
    })
    .catch(function (err) {
      buttonEl.disabled    = false;
      buttonEl.textContent = 'Error — try again';
      console.error(err);
    });
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var vid = parseInt(this.dataset.variant, 10);
      addToCart(vid, {
        'Badge':          state.design.charAt(0).toUpperCase() + state.design.slice(1),
        'Background':     state.bgColour,
        'Design Colour':  state.designColour,
        'Van':            state.van
      }, this);
    });
  }

  /* ── custom design submit ───────────────────────────── */
  if (customSubmit) {
    customSubmit.addEventListener('click', function () {
      var vid  = parseInt(this.dataset.variant, 10);
      var van  = document.getElementById('vbc-custom-van');
      var desc = document.getElementById('vbc-custom-desc');
      var file = document.getElementById('vbc-custom-file');
      addToCart(vid, {
        'Custom Design': 'Yes',
        'Van':           van  ? van.value  : 'Not specified',
        'Description':   desc ? desc.value : '',
        'File Attached': (file && file.files.length > 0) ? file.files[0].name : 'No file'
      }, this);
    });
  }

  /* ── sticky footer dismiss ──────────────────────────── */
  if (stickyClose && stickyFooter) {
    stickyClose.addEventListener('click', function () {
      stickyFooter.style.display  = 'none';
      document.body.style.paddingBottom = '0';
    });
  }

  /* ── FAQ accordion ──────────────────────────────────── */
  document.querySelectorAll('.vbc-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.vbc-faq-q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var a = b.nextElementSibling;
        if (a) a.hidden = true;
      });
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        var answer = this.nextElementSibling;
        if (answer) answer.hidden = false;
      }
    });
  });

  /* ── carousel ───────────────────────────────────────── */
  (function () {
    var track  = document.getElementById('vbc-carousel-track');
    var prev   = document.getElementById('vbc-carousel-prev');
    var next   = document.getElementById('vbc-carousel-next');
    var dotsEl = document.getElementById('vbc-carousel-dots');
    if (!track) return;

    var slides      = track.querySelectorAll('.vbc-carousel__slide');
    var total       = slides.length;
    var current     = 0;
    var dots        = [];
    var touchStartX = 0;

    if (total <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
    }

    if (dotsEl) {
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'vbc-carousel__dot';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () { goTo(idx); });
        })(i);
        dotsEl.appendChild(dot);
        dots.push(dot);
      }
    }

    function goTo(idx) {
      if (idx < 0) idx = total - 1;
      if (idx >= total) idx = 0;
      current = idx;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('vbc-carousel__dot--active', i === current);
      });
    }

    goTo(0);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(dx) > 50) goTo(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });

    setInterval(function () { goTo(current + 1); }, 5500);
  })();

  /* ── init ───────────────────────────────────────────── */
  updatePreview();

})();
